import { useNavigate, useParams } from "react-router";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ParamParseKey } from "react-router";

export const useContactChatRoomPageParams = () => {
	const { hotelID, contactID } = useParams<ParamParseKey<typeof PATHS.HOTEL.CONTACT.CHAT_ROOM>>();

	const navigate = useNavigate();

	/**
	 * @todo hotelID ブランク時の振る舞いを設計
	 */
	if (!(hotelID && contactID)) {
		notifyUserEventInfo({
			title: "無効なURLです",
			description: "",
		});
		navigate(PATHS.TOP);
	}

	return {
		hotelID: hotelID!,
		contactID: contactID!,
	};
};
